import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'nw-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class CardComponent {
    @Input({ transform: booleanAttribute }) disabled: boolean = false;
    @Input({ transform: booleanAttribute }) toggleable: boolean = false;
    @Input({ transform: booleanAttribute }) selected: boolean = false;
    @Input() hasMultipleCards: boolean = false;

    @Output() raiseEvent: EventEmitter<Event> = new EventEmitter<Event>();

    public onClick(event: Event): void {
        if (this.disabled) return;

        this.raiseEvent.emit(event);
    }
}
